import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

// UTILITY
import { externalLink, getExternalUrlParams } from '@/utility/analytics';

// COMPONENTS
import InfoCard from '@/components/Cards/InfoCard';

// UTILITY
import { updateUrl } from '@/utility/common';

// STYLES
import { Content } from './styles';
import { Container } from '../../styles';

class Deals extends PureComponent {
  state = {
    dealsData: [],
  };

  componentDidMount() {
    this.formatDealsData();
  }

  handleVisitSite = href => {
    const { app } = this.props;

    const properties = {
      location: 'deal section',
      href,
      app_id: app.id,
      type: 'app',
      service_name: app.name,
      is_affiliate: !!app.is_affiliate,
    };

    externalLink(properties);
  };

  formatDealsData = () => {
    const { t, deals, analyticsUserId } = this.props;

    const externalUrlParams = getExternalUrlParams({ unique_id: analyticsUserId });

    const dealsData = deals.map(deal => {
      const href = updateUrl(deal.deal_url, externalUrlParams);
      return {
        id: deal.app_deal_id,
        title: deal.deal_title,
        subtitle: deal.deal_text,
        button: {
          href,
          text: deal.button_text || t('buttons.learnMore'),
          component: 'a',
          target: '_blank',
          onClick: () => this.handleVisitSite(href),
        },
      };
    });

    this.setState({ dealsData });
  };

  render() {
    const { t } = this.props;
    const { dealsData } = this.state;

    return (
      <div id="deals">
        <Container className="page-content">
          <Typography className="title m-b-10" variant="h3" align="center">
            {t('appDetails.deals.title')}
          </Typography>
          <Typography className="p3 subtitle" component="p" variant="inherit" align="center">
            {t('appDetails.deals.subtitle')}
          </Typography>
          <Content>
            <Grid container spacing={2}>
              {dealsData.map((data, index) => (
                <Grid key={`deal-${index}`} item xs={12}>
                  <InfoCard type="dark" data={data} />
                </Grid>
              ))}
            </Grid>
          </Content>
        </Container>
      </div>
    );
  }
}

Deals.propTypes = {
  t: PropTypes.func.isRequired,
  deals: PropTypes.array.isRequired,
  app: PropTypes.object.isRequired,
  analyticsUserId: PropTypes.string,
};

export default compose(withTranslation())(Deals);
